export enum TenancyBroadcastMessageType {
  TenancySwitched = 'TenancySwitched',
}

/** A new instance per call; exported for the legacy switcher, which reloads its own tab by hearing its own post. */
export function createTenancyBroadcastChannel() {
  return new BroadcastChannel('bc-app-tenancy');
}

// One instance per tab for the AMS sender and listener: a channel never delivers to the instance that posted.
let sharedChannel: BroadcastChannel | undefined;
const tenancyChannel = (): BroadcastChannel => {
  sharedChannel ??= createTenancyBroadcastChannel();
  return sharedChannel;
};

/** Announces a switch to the other tabs, then reloads this one, which never hears its own announcement. */
export function broadcastTenancySwitchAndReload() {
  tenancyChannel().postMessage(TenancyBroadcastMessageType.TenancySwitched);
  window.location.reload();
}

/** Calls `onSwitch` when another tab announces a switch; returns the unsubscribe. */
export function onTenancySwitch(onSwitch: () => void): () => void {
  const handleMessage = ({ data }: MessageEvent) => {
    if (data === TenancyBroadcastMessageType.TenancySwitched) {
      onSwitch();
    }
  };
  const channel = tenancyChannel();
  channel.addEventListener('message', handleMessage);
  return () => channel.removeEventListener('message', handleMessage);
}
